export default "__VITE_ASSET__94ad11eb__"